var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1331_5184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2133 5.32002C22.6933 2.92002 18.3466 4.04002 16 6.78668C13.6533 4.04002 9.30663 2.90668 5.78663 5.32002C3.91996 6.60002 2.74663 8.76002 2.66663 11.04C2.47996 16.2134 7.06663 20.36 14.0666 26.72L14.2 26.84C15.2133 27.76 16.7733 27.76 17.7866 26.8267L17.9333 26.6933C24.9333 20.3467 29.5066 16.2 29.3333 11.0267C29.2533 8.76002 28.08 6.60002 26.2133 5.32002ZM16.1333 24.7333L16 24.8667L15.8666 24.7333C9.51996 18.9867 5.33329 15.1867 5.33329 11.3334C5.33329 8.66668 7.33329 6.66668 9.99996 6.66668C12.0533 6.66668 14.0533 7.98668 14.76 9.81335H17.2533C17.9466 7.98668 19.9466 6.66668 22 6.66668C24.6666 6.66668 26.6666 8.66668 26.6666 11.3334C26.6666 15.1867 22.48 18.9867 16.1333 24.7333Z",
    fill: "url(#paint0_linear_1331_5184)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1331_5184",
    x1: 15.9996,
    y1: 3.99915,
    x2: 15.9996,
    y2: 27.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720ECF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1331_5184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOutlined);
export default __webpack_public_path__ + "static/media/favorite-outlined.39f677ebf9de062188c2130261c9caac.svg";
export { ForwardRef as ReactComponent };